module.exports = __webpack_public_path__ + "img/show_tc_text_15.efed8ec4.png";